import { useEffect, useState } from "react";
import { isIos, isStandalone } from "@/lib/pwa";
import { Download, Share, X } from "lucide-react";

const DISMISSED_KEY = "iams-install-dismissed";

/**
 * Convite para instalar o CRM no telemóvel. No Android o browser dá-nos o
 * evento de instalação e basta um toque; no iPhone não existe esse evento,
 * por isso mostramos o caminho manual (Partilhar → Adicionar ao ecrã principal).
 */
export function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISSED_KEY) === "1"; } catch { return false; }
  });

  useEffect(() => {
    const onPrompt = (event) => {
      event.preventDefault();
      setDeferred(event);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const ios = isIos();
  if (dismissed || isStandalone()) return null;
  if (!deferred && !ios) return null;

  const close = () => {
    setDismissed(true);
    try { localStorage.setItem(DISMISSED_KEY, "1"); } catch { /* modo privado */ }
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    setDeferred(null);
    if (outcome === "accepted") close();
  };

  return (
    <div className="mb-4 flex items-start gap-3 rounded-xl border border-primary/30 bg-primary/5 p-3 lg:hidden" data-testid="install-prompt">
      <Download className="mt-0.5 h-5 w-5 shrink-0 text-primary" />
      <div className="min-w-0 flex-1">
        <div className="font-poppins text-sm font-semibold">Instalar o CRM no telemóvel</div>
        {ios ? (
          <p className="mt-0.5 text-xs text-muted-foreground">
            No Safari, toca em <Share className="inline h-3 w-3" /> Partilhar e depois em <b>Adicionar ao ecrã principal</b>.
          </p>
        ) : (
          <>
            <p className="mt-0.5 text-xs text-muted-foreground">Fica com ícone próprio e abre em ecrã inteiro.</p>
            <button type="button" onClick={install} className="mt-2 rounded-lg bg-primary px-3 py-1.5 text-xs font-semibold text-black">
              Instalar
            </button>
          </>
        )}
      </div>
      <button type="button" onClick={close} aria-label="Dispensar" className="rounded-md p-1 text-muted-foreground hover:bg-muted hover:text-foreground">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
